import http from './http-common'

export interface Consultation {
    id: number,
    date: string,
    name: string,
    type: string,
    status?: 'COMPLETED' | 'DRAFT',
}

export interface PatientEvent {
    id?: number,
    date: string,
    type: string,
    description: string,
    images?: string[],
}

export type Tags = string[];

export interface Patient {
    id: number,
    name: string,
    phone?: string,
    observation?: string,
    consultationDate?: string,
    returnDate?: string,
    anamnese?: string,
    events?: PatientEvent[],
    consults?: number,
    actions?: string,
    consultations?: Consultation[],
    tags?: Tags,
}

export interface PatientFilter {
    page: number,
    size: number,
    order?: Order,
    search?: string,
    orderBy?: string,
}

export type Order = 'asc'|'desc';

export const getPatients = () => http.get('/patient/all')

export const getPatientsByNameObservation = () => http.get('/patient/name-observation')

export const getPatientNameById = (id: number) => {
    return http.get(`/patient/${id}`);
}

export const getPatientsPaginated2 = (filter: PatientFilter) => {
    let request = `/patient?size=${filter.size}&page=${filter.page}`
    if (filter.search !== undefined) request = request + `&search=${filter.search}`
    if (filter.order !== undefined && filter.orderBy !== undefined) request = request + `&order=${filter.order}&orderBy=${filter.orderBy}`
    return http.get(request)
}

export const getPatientsPaginated = (
    page: number,
    size: number,
    order?: string,
    orderBy?: string,
    filter?: string
) => {
    const params = [
        `size=${size}`,
        `page=${page}`,
        filter ? `search=${filter}` : '',
        order && orderBy ? `order=${order}&orderBy=${orderBy}` : '',
    ].filter(Boolean).join('&');
    return http.get(`/patient?${params}`);
}

export const createPatient = (patient: Patient | FormData, config?: any) =>
    http.post('/patient', patient, config);

export const savePatient = (id: number, patient: Patient | FormData, config?: any) =>
    http.put(`/patient/${id}`, patient, config);

export const deletePatient = (id: number) => http.delete(`/patient/${id}`);

export const updatePatientObservation = (id: number, observation?: string | null) =>
    http.put(`/patient/${id}/observation`, { observation })
